// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productAddedToCartMessageStyles } from "@werner/Overrides/Components/ProductAddedToCartMessage";
import { css } from "styled-components";

productAddedToCartMessageStyles.messageWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
    `,
};
productAddedToCartMessageStyles.title = {
    size: 14,
    weight: "bold",
    color: "text.main",
    css: css`
        display: inline-flex;
        margin-bottom: 4px;
        line-height: 20px;
    `,
};
productAddedToCartMessageStyles.warning = {
    size: 12,
    color: "warning",
    weight: 400,
    css: css`
        display: inline-flex;
        margin-top: 4px;
        line-height: 18px;
    `,
};

productAddedToCartMessageStyles.defaultText = {
    size: 12,
    weight: 400,
    color: "text.main",
    css: css`
        display: inline-flex;
        margin-top: 6px;
        line-height: 18px;
    `,
};
